/** Italian singular/plural: plural(1, "documento", "documenti") -> "1 documento". */
export function plural(n, singular, pluralForm) {
  const num = Number(n) || 0;
  return `${num} ${num === 1 ? singular : pluralForm}`;
}
